/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Dialog_ConfirmInputs */

const vi_await_dialog_confirm = /** @type {(inputs: Await_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn chờ đóng gói`)
};

/**

* @param {Await_Dialog_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_dialog_confirm = /** @type {((inputs?: Await_Dialog_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Dialog_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_dialog_confirm(inputs)
});